/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseAnnouncementStats } from '../../models/api-response-announcement-stats';

export interface GetStats$Params {
  ref: string;
}

export function getStats(http: HttpClient, rootUrl: string, params: GetStats$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAnnouncementStats>> {
  const rb = new RequestBuilder(rootUrl, getStats.PATH, 'get');
  if (params) {
    rb.path('ref', params.ref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseAnnouncementStats>;
    })
  );
}

getStats.PATH = '/v1/api/admin-ui/announcement/{ref}/stats';
